if (typeof window !== 'undefined') {
  window.globalThis = window;
}
